import { v4 as uuidv4 } from "uuid";
import triggerAnalyticsEvent, {
  analyticsConfig,
} from "syf-js-utilities/helpers/triggerAnalyticsEvent";
import { Item } from "@/typings/items";
import {
  BootstrapperObject,
  PageInfo,
  SearchResults,
} from "@/typings/analytics";

declare global {
  interface Window {
    _SFDDL: {
      pageInfo?: PageInfo;
      searchResults: SearchResults;
      clickData: {
        ["data-object"]: string;
        ["data-reason"]: string;
        ["data-type"]: string;
      };
    };
    Bootstrapper: BootstrapperObject;
  }
}

if (navigator.cookieEnabled) {
  const correlationId = sessionStorage.getItem("syfinc-correlationId");

  if (!correlationId) {
    sessionStorage.setItem("syfinc-correlationId", uuidv4());
  }
  analyticsConfig.defaults.Token = sessionStorage.getItem(
    "syfinc-correlationId"
  );
}

analyticsConfig.defaults.Country_Language = "us|eng";
analyticsConfig.defaults.CustomerType = "consumer";
analyticsConfig.defaults.Product = "generic";
analyticsConfig.defaults.PageKind = "home";
analyticsConfig.defaults.PageName = "landingpage";
analyticsConfig.defaults.PageFunction = "searchInspiration-search";
analyticsConfig.defaults.SiteIdentifier = "SyfMarketing";
analyticsConfig.defaults.PNL = "syf corp";

export default triggerAnalyticsEvent;

export function sendResultsToTealium(items: Item[], query: string) {
  if (!window._SFDDL || !items) {
    return;
  }

  let correlationId = "";

  if (navigator.cookieEnabled) {
    const correlationIdFromStorage = sessionStorage.getItem(
      "syfinc-correlationId"
    );

    if (!correlationIdFromStorage) {
      sessionStorage.setItem("syfinc-correlationId", uuidv4());
    }

    correlationId = sessionStorage.getItem("syfinc-correlationId") as string;
  }

  window._SFDDL.searchResults = {
    searchResultsTotal: `${items.length}`,
    searchStage: "N/A",
    searchTerm: query,
    searchTopicOrCategory: "Home Furnishing",
    searchSort: "N/A",
    searchMethod: "search button",
    searchType: "joyhunt search",
    searchOffersType: "Products",
    searchBrands: "N/A",
    searchNetwork: "Synchrony Home Furnishing",
    searchSession: correlationId,
  };
  const my_event = new CustomEvent("syfsearchevent");
  document.dispatchEvent(my_event);
}

export const dispatchCustomEvent = ({
  dataObject,
  dataReason,
  dataType,
}: {
  dataObject: string;
  dataReason: string;
  dataType: string;
}) => {
  window._SFDDL.clickData = {
    ["data-object"]: dataObject,
    ["data-reason"]: dataReason,
    ["data-type"]: dataType,
  };
  const my_event = new CustomEvent("syfjoyhunt");
  document.dispatchEvent(my_event);
};

export const dispatchMKPLCustomEvent = () => {
  if(!initialPageLoad) {
    console.log("custom event triggered");
    const my_event = new CustomEvent("syfjoyhuntpageview ");
    document.dispatchEvent(my_event);
  }
};
